import * as yup from 'yup';

import _ from '../locale';

export const MAX_CHARACTERS_FOR_NAME_FIELD = 32;
export const MIN_CHARACTERS_FOR_PASSWORD_FIELD = 8;

export const EmailSchema = yup.object().shape({
    email: yup
        .string()
        .email(_('error_invalid_email_format'))
        .required(_('error_field_cant_be_empty', { field: 'Email' })),
});

export const PasswordSchema = yup
    .string()
    .required(_('error_field_cant_be_empty', { field: 'Password' }));

export const PasswordWithMinCharactersSchema = PasswordSchema.min(
    MIN_CHARACTERS_FOR_PASSWORD_FIELD,
    _('error_field_should_be_minimum_characters', {
        field: 'Password',
        min: MIN_CHARACTERS_FOR_PASSWORD_FIELD,
    })
);

export const EmailPasswordAuthSchema = EmailSchema.shape({
    password: PasswordSchema,
});

export const ProfileSchema = EmailSchema.shape({
    first_name: yup
        .string()
        .trim()
        .max(
            MAX_CHARACTERS_FOR_NAME_FIELD,
            _('error_field_should_not_exceed_maximum_characters', {
                field: 'First name',
                max: MAX_CHARACTERS_FOR_NAME_FIELD,
            })
        )
        .required(_('error_field_cant_be_empty', { field: 'First name' })),
    last_name: yup
        .string()
        .trim()
        .max(
            MAX_CHARACTERS_FOR_NAME_FIELD,
            _('error_field_should_not_exceed_maximum_characters', {
                field: 'Last name',
                max: MAX_CHARACTERS_FOR_NAME_FIELD,
            })
        )
        .required(_('error_field_cant_be_empty', { field: 'Last name' })),
});
